/**
 * @generated SignedSource<<0bed955956d13a44cdbac861bbb2e1ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductOrderFooter_order$data = {
  readonly id: string;
  readonly total: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useIsPackageOrderDue_order">;
  readonly " $fragmentType": "StoreProductOrderFooter_order";
};
export type StoreProductOrderFooter_order$key = {
  readonly " $data"?: StoreProductOrderFooter_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrderFooter_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductOrderFooter_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsPackageOrderDue_order"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "5282415ee0ba3737542d142fcbf44c1b";

export default node;
